module.exports = "/_next/static/images/recover-d1e206e1f476efc6b8b17d82fd1d3daa.svg";